import { SimpleLineIcons } from '@expo/vector-icons'
import { Link } from 'expo-router'
import { StyleSheet, TouchableOpacity, View } from 'react-native'
import { mesaColorNames } from '@/src/common/theme'
import type { ProfileProps } from '@/src/common/components/Profile/ProfileProps'
import { useLoggedInQuery } from '@/src/common/gql/MesaGql'
import { graphql } from '@api/mesa'
import { useRefetchQueryOnFocus } from '../../hooks/useRefetchQueryOnFocus'

export const GET_UNREAD_NOTIFICATIONS = graphql(`
  query GetUnreadNotifications {
    getUserNotifications(pushNotificationStatus: RECEIVED) {
      __typename
      notifications {
        __typename
        id
      }
    }
  }
`)

export function NotificationsEntryPoint({
  menuWrapperProps,
  noticationWrapperProps,
  menuIconProps,
}: Pick<ProfileProps, 'menuWrapperProps' | 'noticationWrapperProps' | 'menuIconProps'>) {
  const { data: unreadNotifications } = useRefetchQueryOnFocus(
    useLoggedInQuery(GET_UNREAD_NOTIFICATIONS, {
      fetchPolicy: 'cache-and-network',
      // every hour
      pollInterval: 60 * 60 * 1000,
    }),
  )

  return (
    <Link href="/main/notification-center" push asChild>
      <TouchableOpacity
        {...menuWrapperProps}
        style={StyleSheet.flatten([{ alignItems: 'flex-end' }, noticationWrapperProps?.style])}
        testID="profile-notifications"
        hitSlop={10}
      >
        <SimpleLineIcons
          name="bell"
          size={24}
          color={menuIconProps?.color || mesaColorNames['Acre Turquoise/800 #086762']}
        />
        {unreadNotifications?.getUserNotifications.notifications.length ? (
          <View
            style={{
              position: 'absolute',
              top: -4,
              left: -4,
              zIndex: 1,
              alignItems: 'center',
              flexDirection: 'row',
              justifyContent: 'center',
              backgroundColor: mesaColorNames['Mesa Third #E78A43'],
              borderRadius: 12,
              height: 8,
              width: 8,
            }}
          />
        ) : null}
      </TouchableOpacity>
    </Link>
  )
}
